import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';

const DisabledWrapper = styled.div`
  pointer-events: none;
  opacity: 0.5;
  z-index: 1;
`;

const PermissionsHOC = ({
  WrappedComponent = <></>,
  requiredPermissions = [],
  isHideOnMissingPermissions = true,
  DefaultOnHideComponent = <></>
} = {}) => {
  const account = useSelector(myAccountSelector);

  if (!requiredPermissions.length) {
    return WrappedComponent;
  }

  if (requiredPermissions.includes(account?.type_id)) {
    return WrappedComponent;
  }

  if (isHideOnMissingPermissions) {
    return DefaultOnHideComponent;
  }

  return (
    <Tooltip
      title='Missing required permissions'
      data-testid='missing-permissions-tooltip'
    >
      <div>
        <DisabledWrapper>{WrappedComponent}</DisabledWrapper>
      </div>
    </Tooltip>
  );
};

export default PermissionsHOC;
